import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../../components/dashboardHeader";
import DynamicTabsDrawer from "../../../components/drawer";
import { setActiveTab } from "../../../lib/redux/slices/activeTabSlice";
import UserCart from "./Cart";
import PurchaseInvoice from "./PurchaseInvoice";
import { t } from "i18next";

const tabs = [
  {
    label: "myCart",
    value: "ecommerce_cart",
  },
  {
    label: "myOrders",
    value: "purchase_invoice",
  },
];

const UserEcommerceDetailPage = () => {
  const navigate = useNavigate();
  const dispacth = useDispatch();
  const activeTab = useSelector((state) => state.activeTabReducer.tabs);

  const handleChangeTab = (value) => {
    dispacth(setActiveTab({ ...activeTab, user_cart: value }));
  };

  return (
    <DashboardHeader>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2.5}>
          <DynamicTabsDrawer
            primaryHeading={t("eComPurchasing")}
            tabs={tabs}
            activeTab={activeTab.user_cart}
            showBackBtn={true}
            handleBack={() => navigate("/dashboard")}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.5}>
          {activeTab.user_cart === "ecommerce_cart" ? (
            <UserCart />
          ) : activeTab.user_cart === "purchase_invoice" ? (
            <PurchaseInvoice />
          ) : null}
        </Grid>
      </Grid>
    </DashboardHeader>
  );
};

export default UserEcommerceDetailPage;
